import React, { Component, Fragment } from "react";
import {
  Form,
  Input,
  Pagination,
  Dropdown,
  Menu,
  Select,
  Collapse,
  Table,
  Modal,
  Spin,
  Tabs,
} from "antd";
import { DeleteOutlined } from "../../../../node_modules/@ant-design/icons";

import ChangePath from "../../ServiceApi";

const { Panel } = Collapse;
const { Option } = Select;

class CreateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      title: "Create Form",
      data: [
        {
          name: "BKKN_01",
          area: "BKK - Bangkok (Master)",
          total: 1000,
          is_master: true,
        },
        {
          name: "BKKN_02",
          area: "BKK - Bangkok",
          total: 2000,
          is_master: false,
        },
        {
          name: "BKKN_03",
          area: "BKK - Bangkok",
          total: 3000,
          is_master: false,
        },
        {
          name: "BKKN_04",
          area: "BKK - Bangkok",
          total: 1000,
          is_master: false,
        },
        {
          name: "BKKN_05",
          area: "BKK - Bangkok",
          total: 4000,
          is_master: false,
        },
      ],
      step: 0,
      category: [
        {
          title: "BKK - Bangkok",
          total: 1000,
          sub: [
            { title: "Bangkok Master", total: 500 },
            { title: "Bangkok North", total: 250 },
            { title: "Bangkok South", total: 250 },
          ],
        },
        {
          title: "North",
          total: 300,
          sub: [
            { title: "North Master", total: 150 },
            { title: "North 2", total: 150 },
          ],
        },
        {
          title: "South",
          total: 300,
          sub: [
            { title: "South Master", total: 150 },
            { title: "South 2", total: 150 },
          ],
        },
      ],
      filter: [],
      form_type: [
        {
          name: "Receipt",
          icon_name: "Receipt.svg",
          form_id: 1,
        },
        {
          name: "Requisition",
          icon_name: "Requisition.svg",
          form_id: 2,
        },
        {
          name: "Reserve",
          icon_name: "Reserve.svg",
          form_id: 3,
        },
        {
          name: "Return",
          icon_name: "Return.svg",
          form_id: 4,
        },
        {
          name: "Transfer",
          icon_name: "Transfer.svg",
          form_id: 5,
        },
      ],
      mat_row: [
        <div key="0" className="row" style={{ marginTop: 20 }}>
          <div className="col-12">
            <h3 className="font-thai-b fs-18 c-blue mb-0">
              <span
                style={{
                  font: "Semi Bold 18px/13px ThaiSans Neue",
                  letterSpacing: "0.36px",
                  color: "#6F6F6F",
                  textTransform: "capitalize",
                  opacity: 1,
                }}
              >
                Requisition Form No.{" "}
              </span>
              XXXXX
            </h3>
          </div>
        </div>,
        <div
          key="1"
          className="row"
          style={{
            borderTop: "2px solid #E8CD00",
            borderBottom: "2px solid #E8CD00",
            margin: "10px",
          }}
        >
          <div className="col-1 text-center">Item</div>
          <div className="col-5">Description</div>
          <div className="col-1 text-center">Quantity</div>
          <div className="col-1 text-center">Unit</div>
          <div className="col-2 text-center">Price</div>
          <div className="col-2 text-center">
            <div className="row">
              <div className="col-10">
                <span> Total </span>
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </div>,
        <div key="2" className="row static-row" style={{ margin: "5px 10px" }}>
          <div className="col-1 text-center">1</div>
          <div className="col-5">
            <Form.Item
              name="desc"
              style={{ marginBottom: 0 }}
              rules={[
                {
                  required: true,
                  message: "Description is required",
                  marginBottom: 0,
                },
              ]}
            >
              <Input
                className="font-mont-r fs-12"
                type="text"
                size="large"
                placeholder="Optional Description"
              />
            </Form.Item>
          </div>
          <div className="col-1 text-center">
            <Form.Item
              name="qty"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: "Quantity is required" }]}
            >
              <Input
                className="font-mont-r fs-12 text-right"
                type="number"
                size="large"
                placeholder=""
                defaultValue={0.0}
              />
            </Form.Item>
          </div>
          <div className="col-1 text-center">
            <Select placeholder="Unit">
              <Option value={0}>ea</Option>
              <Option value={1}>dozen</Option>
            </Select>
          </div>
          <div className="col-2 text-center">
            <Form.Item
              name="price"
              style={{ marginBottom: 0 }}
              rules={[{ required: true, message: "Price is required" }]}
            >
              <Input
                className="font-mont-r fs-12 text-right"
                type="number"
                size="large"
                placeholder=""
                defaultValue={0.0}
              />
            </Form.Item>
          </div>
          <div className="col-2 text-center">
            <div className="row">
              <div className="col-10">
                <Input
                  className="font-mont-r fs-12 text-right"
                  style={{ cursor: "default" }}
                  type="number"
                  size="large"
                  placeholder=""
                  defaultValue={0.0}
                  readOnly
                />
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </div>,
        <div key="3" className="row addrow" style={{ margin: "10px" }}>
          <div className="col-1"></div>
          <div className="col-5">
            <button
              type="button"
              onClick={() => this.onAddrow()}
              style={{
                padding: "5px",
                width: "100%",
                border: "1px dashed #9A98E0",
                cursor: "pointer",
                textDecoration: "underline",
                textAlign: "center",
                color: "#00f",
                backgroundColor: "#fff",
              }}
              onMouseOver={function (ev, ele) {
                ev.target.style.backgroundColor = "rgba(0,0,199,0.1)";
              }}
              onMouseOut={function (ev, ele) {
                ev.target.style.backgroundColor = "#fff";
              }}
            >
              {" "}
              + Add row
            </button>
          </div>
          <div className="col-1 text-center"></div>
          <div className="col-1 text-center"></div>
          <div className="col-2 text-center"></div>
          <div className="col-2 text-center"></div>
        </div>,
      ],
      form_selected: 1,
    };
  }

  componentDidMount() {
    this.setState({ filter: this.state.category });
  }

  onFilter(step, title, subTitle) {
    const filter = [];
    if (step === 0) {
      this.setState({
        step: step,
        filter: this.state.category,
      });
    } else if (step === 1) {
      this.state.category.filter((item) => {
        if (item.title === title) {
          filter.push(item);
        }
      });
      this.setState({
        step: step,
        filter: filter,
      });
    } else {
      this.state.filter[0].sub.filter((item) => {
        if (item.title === subTitle) {
          filter.push({
            title: this.state.filter[0].title,
            total: this.state.filter[0].total,
            sub: [item],
          });
        }
      });
      this.setState({
        step: step,
        filter: filter,
      });
    }
  }
  onModal(name, mode, visible) {
    console.log("clicked");
    if (visible == false) {
      this.formRef.current.resetFields();
    }
    if (name == "main") {
      this.setState({
        visible: visible,
        mode,
      });
    } else {
      this.setState({
        visible_sub: visible,
        mode,
      });
    }
  }
  onAddrow() {
    const thismatrow = this.state.mat_row;
    console.log(thismatrow);
    thismatrow.push(null);
    thismatrow[thismatrow.length - 1] = thismatrow[thismatrow.length - 2];
    thismatrow[thismatrow.length - 2] = (
      <div
        key={thismatrow.length - 1}
        className="row added-row"
        style={{ margin: "5px 10px" }}
      >
        <div className="col-1 text-center">{thismatrow.length - 3}</div>
        <div className="col-5">
          <Form.Item
            name="desc"
            style={{ marginBottom: 0 }}
            rules={[
              {
                required: true,
                message: "Description is required",
                marginBottom: 0,
              },
            ]}
          >
            <Input
              className="font-mont-r fs-12"
              type="text"
              size="large"
              placeholder="Optional Description"
            />
          </Form.Item>
        </div>
        <div className="col-1 text-center">
          <Form.Item
            name="qty"
            style={{ marginBottom: 0 }}
            rules={[{ required: true, message: "Quantity is required" }]}
          >
            <Input
              className="font-mont-r fs-12 text-right"
              type="number"
              size="large"
              placeholder=""
              defaultValue={0.0}
            />
          </Form.Item>
        </div>
        <div className="col-1 text-center">
          <Select placeholder="Unit">
            <Option value={0}>ea</Option>
            <Option value={1}>dozen</Option>
          </Select>
        </div>
        <div className="col-2 text-center">
          <Form.Item
            name="price"
            style={{ marginBottom: 0 }}
            rules={[{ required: true, message: "Price is required" }]}
          >
            <Input
              className="font-mont-r fs-12 text-right"
              type="number"
              size="large"
              placeholder=""
              defaultValue={0.0}
            />
          </Form.Item>
        </div>
        <div className="col-2 text-center">
          <div className="row">
            <div className="col-10">
              <Input
                className="font-mont-r fs-12 text-right"
                style={{ cursor: "default" }}
                type="number"
                size="large"
                placeholder=""
                defaultValue={0.0}
                readOnly
              />
            </div>
            <div className="col-2 p-0">
              <DeleteOutlined
                style={{
                  color: "#fff",
                  padding: 5,
                  fontSize: 13,
                  cursor: "pointer",
                  backgroundColor: "#f00",
                  borderRadius: 50,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
    this.setState({
      mat_row: thismatrow,
    });
  }
  async btnFormSelected(n) {
    /*
      const job_type_data = await Api.Post("get_job_type", {
        pk_id: null,
        fk_id: n,
        is_active: "1",
        effective: "1",
        sql_where: null,
      });*/
    console.log(n);

    this.setState({
      form_selected: n,
    });
  }
  render() {
    const { title, data, step, filter, mat_row } = this.state;

    const form_type = this.state.form_type.map((form_type, index) => {
      return (
        <div
          key={index}
          className={"col-2 " + "p0"}
          style={{ marginBottom: "10px" }}
        >
          <button
            type="button"
            className={
              this.state.form_selected == form_type.form_id
                ? "btndetailshow"
                : "btndetailhide"
            }
            onClick={this.btnFormSelected.bind(this, form_type.form_id)}
          >
            <img
              style={{
                float: "right",
                marginRight: "10px",
              }}
              src={
                this.state.form_selected == form_type.form_id
                  ? ChangePath.absoluteUrl("/icon/job_show.svg")
                  : ChangePath.absoluteUrl("/icon/job_dis.svg")
              }
            />
            <br className="mt-2" />
            <img
              style={{
                float: "center",
                marginLeft: "-15px",
              }}
              src={ChangePath.absoluteUrl("/icon/" + form_type.icon_name)}
            />
            <span
              style={{
                marginLeft: "-20px",
                fontSize: "14px",
                color: "#0500A3",
              }}
            >
              <br className="mt-2" />
              {form_type.name}
            </span>
          </button>
        </div>
      );
    });
    return (
      <div className="container-fluid">
        <div className="row" style={{ marginBottom: 5 }}>
          <div className="col-6">
            <h3
              className="c-blue font-mont-b fs-18"
              style={{ fontWeights: "bold", marginTop: 5 }}
            >
              CREATE FORM (FOR MAINTENANCE)
            </h3>
          </div>
          <div className="col-6">
            <button
              style={{ height: "36px", marginTop: -5 }}
              className="btn btn-warning float-right"
              onClick={() => this.onModal("team", true)}
            >
              <img src={ChangePath.absoluteUrl("/icon/plus.svg")} className="mr-2" />
              Add Material
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card-table-ma" style={{ padding: "25px 30px" }}>
              <Form>
                <div className="row">
                  <div className="col-8 offset-2 mr-2">
                    <h3 className="font-thai-b fs-18 c-blue mb-0">
                      Select Form <span style={{ color: "red" }}>*</span>
                    </h3>
                  </div>
                  <div className="col-8 offset-2 mr-2">
                    <div
                      className="row d-flex justify-content-around"
                      style={{ padding: "5px 30px 5px 30px" }}
                    >
                      {form_type}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4 offset-2">
                    <h3 className="font-thai-b fs-18 c-blue mb-0">
                      Warehouse <span style={{ color: "red" }}>*</span>
                    </h3>
                  </div>
                  <div className="col-4 mr-2">
                    <h3 className="font-thai-b fs-18 c-blue mb-0">
                      Sub Warehouse <span style={{ color: "red" }}>*</span>
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4 offset-2">
                    <Select
                      style={{ width: 300 }}
                      placeholder="Select Warehouse"
                    >
                      <Option value={0}>All</Option>
                      <Option value={1}>Warehouse</Option>
                      <Option value={2}>Sub Warehouse</Option>
                    </Select>
                  </div>
                  <div className="col-4 mr-2">
                    <Select
                      style={{ width: 300 }}
                      placeholder="Select Sub Warehouse"
                    >
                      <Option value={0}>All</Option>
                      <Option value={1}>Warehouse</Option>
                      <Option value={2}>Sub Warehouse</Option>
                    </Select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4 offset-2">
                    <h3 className="font-thai-b fs-18 c-blue mb-0">
                      Team <span style={{ color: "red" }}>*</span>
                    </h3>
                  </div>
                  <div className="col-4 mr-2">
                    <h3 className="font-thai-b fs-18 c-blue mb-0">
                      Team Lead <span style={{ color: "red" }}>*</span>
                    </h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4 offset-2">
                    <Select style={{ width: 300 }} placeholder="Select Team">
                      <Option value={0}>All</Option>
                      <Option value={1}>Warehouse</Option>
                      <Option value={2}>Sub Warehouse</Option>
                    </Select>
                  </div>
                  <div className="col-4 mr-2">
                    <Select
                      style={{ width: 300 }}
                      placeholder="Team Lead auto select"
                    >
                      <Option value={0}>All</Option>
                      <Option value={1}>Warehouse</Option>
                      <Option value={2}>Sub Warehouse</Option>
                    </Select>
                  </div>
                </div>
                <div className="mat-table-container">{this.state.mat_row}</div>
              </Form>

              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
              <br></br>

              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h3 className="font-mont-sb fs-18 c-blue mb-0">All Area</h3>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-4">
                <Select style={{ width: 200 }} placeholder="Select" value={0}>
                  <Option value={0}>All</Option>
                  <Option value={1}>Warehouse</Option>
                  <Option value={2}>Sub Warehouse</Option>
                </Select>

                <span>
                  <span className="font-thai-sb fs-18">Sort by : </span>
                  <Select style={{ width: 80 }} placeholder="Select">
                    <Option value="rmb">RMB</Option>
                    <Option value="dollar">Dollar</Option>
                  </Select>
                </span>
              </div>

              <div className="row">
                {data.map((item, index) => (
                  <div className="col-3" key={index}>
                    <div className="card-warehouse">
                      <div className="image">
                        {item.is_master === true ? (
                          <div className="master">
                            <img src={ChangePath.absoluteUrl("/icon/star.svg")} alt="" />
                          </div>
                        ) : null}

                        <img
                          src={ChangePath.absoluteUrl("/img/warehouse.png")}
                          alt=""
                          className="img-fluid"
                        />
                      </div>
                      <div className="detail">
                        <div className="dropdown">
                          <Dropdown
                            overlay={
                              <Menu>
                                <Menu.Item key="0">
                                  <a
                                    onClick={() =>
                                      this.onRenameFolder(index, item)
                                    }
                                  >
                                    <img
                                      src={ChangePath.absoluteUrl("/icon/rename_dropdown.svg")}
                                      className="mr-2"
                                    />
                                    Edit
                                  </a>
                                </Menu.Item>
                                <Menu.Item key="1">
                                  <a className="c-red">
                                    <img
                                      src={ChangePath.absoluteUrl("/icon/delete_dropdown.svg")}
                                      className="mr-2"
                                    />
                                    Delete
                                  </a>
                                </Menu.Item>
                              </Menu>
                            }
                            trigger={["click"]}
                          >
                            <a
                              className="ant-dropdown-link c-blue"
                              onClick={(e) => e.preventDefault()}
                            >
                              <svg
                                className="bi bi-three-dots"
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </a>
                          </Dropdown>
                        </div>

                        <h5 className="font-thai-b fs-18 c-blue mb-0">
                          {item.name}
                        </h5>
                        <span className="font-thai-b fs-18 c-blue">
                          {item.area}
                        </span>
                        <div className="d-flex justify-content-between">
                          <span className="font-thai-b fs-18 c-black">
                            Total
                          </span>
                          <span className="font-thai-b fs-18 c-green">
                            {item.total}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Pagination className="text-right" total={50} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateForm;
